import { render, staticRenderFns } from "./TuiEditor.vue?vue&type=template&id=a4f66f18&scoped=true"
import script from "./TuiEditor.vue?vue&type=script&lang=js"
export * from "./TuiEditor.vue?vue&type=script&lang=js"
import style0 from "./TuiEditor.vue?vue&type=style&index=0&id=a4f66f18&prod&scoped=true&lang=css"
import style1 from "./TuiEditor.vue?vue&type=style&index=1&id=a4f66f18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f66f18",
  null
  
)

export default component.exports